import { applyQueryParameter } from '@/routing/QueryParamRoute';
import history from '@/routing/history';
import { SearchParams } from 'nike-ui/src/common/routing/types';
import { History } from 'history';

export const pageChangeParam = (searchParams: SearchParams, state?: History.LocationState) => db => {
    setTimeout(() => {
        const [search, alreadyApplied] = applyQueryParameter(history.location, searchParams);
        const pathname = history.location.pathname;
        if (!alreadyApplied) {
            return history.push({ pathname, search, state: addMetaToState(state) });
        }
    }, 0);
    return db;
};

//sluzi na udrziavanie informacii o predchadzajucej stranke, kvoli funkcionalite back buttonu
export const addMetaToState = (state: History.LocationState = {}) => Object.assign({ fromApp: true }, state);
